import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge has to be told about our type scale, because tokens.css
 * replaces Tailwind's default one. Without this, `cx('text-xs', 'text-xl')`
 * would keep both and the cascade would decide — which is exactly the kind of
 * quiet inconsistency ui-v2 exists to prevent.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: ['micro', 'xs', 'sm', 'base', 'md', 'lg', 'xl', '2xl', '3xl'],
        },
      ],
    },
  },
});

/**
 * Compose class names, with later Tailwind utilities winning over earlier ones.
 *
 * Use this anywhere a component accepts a `className` override, so a caller's
 * `text-lg` actually replaces the primitive's `text-sm` instead of racing it.
 */
export function cx(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
